import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-new-catalog-confirmation-dialog',
  templateUrl: './new-catalog-confirmation-dialog.component.html',
  styleUrls: ['./new-catalog-confirmation-dialog.component.scss']
})
export class NewCatalogConfirmationDialogComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<NewCatalogConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { status: 'Draft' | 'Approved', hasSourceAgent: boolean, source: 'agents' | 'catalogs', agentId: number | null } = { status: 'Draft', hasSourceAgent: false, source: 'catalogs', agentId: null }
  ) {}

  ngOnInit(): void {}

  goBack() {
    this.dialogRef.close(true)
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
